import {forwardRef, useContext} from "react";
import {AccordionCollapse} from "react-bootstrap";
import AccordionItemContext from "react-bootstrap/AccordionItemContext";

import {AccordionStyleContext} from "@/components/accordion/Accordion.tsx";
import {AccordionBodyProps} from "@/components/accordion/subComponents/AccordionBody/AccordionBody.types.ts";

import styles from "./AccordionBody.module.scss";

const AccordionBody = forwardRef<HTMLDivElement, AccordionBodyProps>(({children, className, ...rest}, ref) => {
  const {eventKey} = useContext(AccordionItemContext);
  const style = useContext(AccordionStyleContext);

  return (
    <AccordionCollapse eventKey={eventKey} {...rest} className={styles[style.variant || "default"]}>
      <div ref={ref} className={className}>
        {children}
      </div>
    </AccordionCollapse>
  );
});

AccordionBody.displayName = "AccordionBody";
export {AccordionBody};
